import { useEffect, useState } from 'react';
import { catchResponseError } from 'packages/helpers/helpers';
import creativeEditorService, { type CreativeTemplate } from 'packages/services/creativeEditorService';

export type { CreativeTemplate };

export default function useCreativeTemplate(id?: number, lastPublished = true) {
    const [template, setTemplate] = useState<CreativeTemplate | null>(null);

    useEffect(() => {
        if (!id) {
            return;
        }

        const req = creativeEditorService.getCreativeTemplate(id, lastPublished);

        req.then((res) => {
            if (res.status >= 400) {
                throw new Error('Failed to fetch creative template');
            }

            setTemplate(res.json);
        }).catch(catchResponseError);

        return () => creativeEditorService.abortRequest(req);
    }, [id, lastPublished]);

    return template;
}
